export default "__VITE_ASSET___WuKII4LgHpgQZfaHZdoqg__"